import React, { useEffect, useState } from "react";
import Joi from "joi";
import { useNavigate, useParams } from "react-router-dom";
import { validateFormData } from "../../utils/validation";
import { errorMsg, successMsg } from "../../utils/customFn";
import useApiRequest from "../../hook/useApiRequest";
import { API_ENDPOINTS } from "../../constants/endPoints";
import { setProfileData } from "../../redux/user/slice/userAuthSlice";
import { useDispatch } from "react-redux";

const useAddCustomerUtils = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, fetchData } = useApiRequest();
  const [formErrors, setFormErrors] = useState({});
  const [changePassword, setChangePassword] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    image: "",
    changePassword: false,
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const fetchProfileData = async () => {
    const response = await fetchData(`${API_ENDPOINTS?.get_profile}`, navigate);

    if (response) {
      console.log(response);
      setFormData((prev) => ({
        ...response,
      }));
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, [id]);

  const submitForm = async (e) => {
    e.preventDefault();
    try {
      let validationSchema = Joi.object({});

      if (formData.changePassword) {
        validationSchema = validationSchema.append({
          currentPassword: Joi.string()
            .required()
            .messages({
              "any.required": "Current password is required.",
              "string.base": "Current password must be a string.",
            }),
          newPassword: Joi.string()
            .min(6)
            .required()
            .messages({
              "any.required": "New password is required.",
              "string.min": "New password must be at least 6 characters long.",
              "string.base": "New password must be a string.",
            }),
          confirmPassword: Joi.string()
            .valid(Joi.ref("newPassword"))
            .required()
            .messages({
              "any.only": "Confirm password must match new password.",
              "any.required": "Confirm password is required.",
              "string.base": "Confirm password must be a string.",
            }),
        });
      }

      validationSchema = validationSchema.options({
        abortEarly: false,
        allowUnknown: true,
      });

      const { status, errors } = await validateFormData(
        formData,
        validationSchema
      );

      setFormErrors(errors);
      if (!status) return;

      const url = `${API_ENDPOINTS.update_profile}`;
      const response = await fetchData(url, navigate, "PATCH", formData);

      if (response) {
        successMsg("Profile has been successfully updated.");
        // setFormData({
        //   changePassword: false,
        //   currentPassword: "",
        //   newPassword: "",
        //   confirmPassword: "",
        // });
        dispatch(setProfileData(response));
      }
    } catch (err) {
      errorMsg("An error occurred during submission.");
      console.error("Error during form submission:", err);
    } finally {
    }
  };

  return {
    formData,
    loading,
    fetchData,
    handleFormChange,
    submitForm,
    formErrors,
    setFormData,
    setChangePassword,
    changePassword,
  };
};

export default useAddCustomerUtils;
